import { createGlobalStyle } from 'styled-components';
import { colorSchema } from 'utils/style';

const GlobalStyles = createGlobalStyle`
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,500;0,700;1,100&display=swap');

  html, body {
    height: 100%;
    font-family: 'Roboto', sans-serif;
    width: 100%;
    line-height: 1.2;
  }

  body {
    background-color: ${colorSchema('grey200')};
    display: flex;
    align-items: stretch;
  }

  @media print {
    html, body {
      overflow: auto;
      height: auto;
      width: auto;
    }
  }

  #root {
    width: 100%;
    > svg {
    display: none;
  }
  }

  a {
    color: black;
    text-decoration: none;
  }

  input::-webkit-contacts-auto-fill-button {
    visibility: hidden;
    display: none !important;
    pointer-events: none;
    position: absolute;
    right: 0;
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: none;
  }

  .visually-hidden {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    clip: rect(1px, 1px, 1px, 1px);
    white-space: nowrap; /* added line */
}

  .Toastify__toast.toast {
    border-radius: 4px;
    font-family: 'Roboto', sans-serif;
    padding: 0;
  }

  .toast {
    &__body {
      color: ${colorSchema('grey900')}
    }

    &__progress {
      background: ${colorSchema('primary')} !important;
    }

    .Toastify__toast-body {
      margin: 0;
    }

    .Toastify__close-button {
      color: ${colorSchema('grey900')};
      position: absolute;
      right: 1.6rem;
      top: 2.2rem;
      font-weight: bold;
    }
  }
`;

export default GlobalStyles;
